
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["pencil_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('style')]),_c('path',{attrs:{"d":"M864 0c88.352 0 160 71.648 160 160 0 36.032-11.904 69.248-32 96l-64 64L704 96l64-64c26.752-20.096 59.968-32 96-32zM64 736L0 1024l288-64 592-592-224-224L64 736zm651.584-372.416l-448 448-55.168-55.168 448-448 55.168 55.168z"}})])
          )
        }
      }
    